import { render, staticRenderFns } from "./basictable.vue?vue&type=template&id=a928143e"
import script from "./basictable.vue?vue&type=script&lang=js"
export * from "./basictable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports